"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebSocketService = void 0;
const reconnecting_websocket_1 = __importDefault(require("../external-modules/reconnecting-websocket/reconnecting-websocket"));
const WebSocketHeartBeat_1 = require("./WebSocketHeartBeat");
const WebSocketListener_1 = require("./WebSocketListener");
class WebSocketService {
    constructor({ baseUrl, protocols, options, queryParams, logger, errorTracking, }) {
        this.subscriptions = new Map();
        this.addSubscriptionOnOpen = (key, listener) => {
            this.subscriptions.set(key, listener);
        };
        this.getSubscriptionOnOpen = (key) => {
            return this.subscriptions.get(key);
        };
        this.removeSubscriptionOnOpen = (key) => {
            this.subscriptions.delete(key);
        };
        /**
         *  Set up WebSocket connection for a new user and
         *  basic listeners to handle events
         */
        this.initSocket = ({ protocols, options }) => {
            this.rws = new reconnecting_websocket_1.default(this.fullUrl, protocols, options);
            this.rws.onmessage = this.onMessage;
        };
        this.onOpen = (callback) => {
            this.rws.onopen = (event) => {
                this.logger('WebSocket:onOpen:connection_opened', event);
                for (const listener of [...this.subscriptions.values()]) {
                    listener();
                }
                this.heartbeat.check();
                callback === null || callback === void 0 ? void 0 : callback(event);
            };
        };
        this.onClose = (callback) => {
            this.rws.onclose = (event) => {
                this.logger('WebSocket:onClose:connection_closed', event);
                this.heartbeat.reset();
                callback === null || callback === void 0 ? void 0 : callback(event);
            };
        };
        this.onError = (callback) => {
            this.rws.onerror = (error) => {
                this.logger('WebSocket:onError:error', error);
                this.errorTracking((error === null || error === void 0 ? void 0 : error.message) || 'An error occurred.', error, false);
                callback === null || callback === void 0 ? void 0 : callback(error);
            };
        };
        this.throwError = (error) => {
            this.logger('WebSocket:onError:error', error);
            this.errorTracking('An error occurred.', error, true);
        };
        /**
         * Handler that receives the actual messages from the WebSocket API
         * For now it simply returns the parsed message body to the appropriate
         * registered handler
         * @param messageEvent Message body received from WebSocket
         */
        this.onMessage = (messageEvent) => {
            this.heartbeat.check();
            if (!messageEvent)
                return;
            if (!messageEvent.data) {
                this.throwError(new ErrorEvent('No data received. Please  contact your administrator.'));
                return;
            }
            try {
                const message = JSON.parse(messageEvent.data);
                if (message.statusCode >= 400) {
                    this.throwError(new ErrorEvent(message.message || 'An error occurred. Please contact your administrator.'));
                    return;
                }
                this.topicListener.relayMessageToListener(message);
            }
            catch (e) {
                this.logger('WebSocket:onMessage:error', messageEvent.data);
                throw e;
            }
        };
        /**
         *  Used by application to send message to the WebSocket API Gateway
         *  @param message String message
         *  message {
         *    action,
         *    topic,
         *    data
         *  }
         */
        this.sendMessage = (message) => {
            this.logger('WebSocket:sendMessage:message', message);
            this.rws.send(JSON.stringify(message));
        };
        this.reconnect = () => {
            this.rws.reconnect();
            this.logger('WebSocket:close:connection_reestablished');
        };
        this.close = () => {
            this.rws.close();
            this.logger('WebSocket:close:connection_closed');
        };
        this.setAuthToken = (authToken) => {
            this.queryParams = Object.assign(Object.assign({}, this.queryParams), { authorization: authToken });
            this.rws.setUrl(this.fullUrl);
        };
        this.isListening = (topic, eventType) => {
            return this.readyState === this.OPEN && !!this.topicListener.getListener(topic, eventType);
        };
        this.logger = logger;
        this.errorTracking = errorTracking;
        this.baseUrl = baseUrl;
        this.queryParams = queryParams;
        this.initSocket({ protocols, options });
        this.heartbeat = new WebSocketHeartBeat_1.WebSocketHeartBeat(this.rws, queryParams, options);
        this.topicListener = new WebSocketListener_1.WebSocketListener(logger);
    }
    get fullUrl() {
        const strQueryParams = Object.keys(this.queryParams)
            .map((key) => `${key}=${this.queryParams[key]}`)
            .join('&');
        return `${this.baseUrl}?${strQueryParams}`;
    }
    get url() {
        return this.rws.url;
    }
    get readyState() {
        return this.rws.readyState;
    }
    get OPEN() {
        return this.rws.OPEN;
    }
    get CLOSED() {
        return this.rws.CLOSED;
    }
    get CLOSING() {
        return this.rws.CLOSING;
    }
    get CONNECTING() {
        return this.rws.CONNECTING;
    }
}
exports.WebSocketService = WebSocketService;
//# sourceMappingURL=WebSocketService.js.map